import { z } from 'zod';
import { normalizePhone } from '../phone.js';

/**
 * The dev simulator (`/dev/simulator`, local only; the worker refuses it unless
 * DEV_SIMULATOR_ENABLED=true outside production). It injects a signed fake inbound text through the
 * real webhook path: save first, then the opt-out gate and everything after it.
 */

const Phone = z.string().transform((value, ctx) => {
  const p = normalizePhone(value);
  if (!p.ok) {
    ctx.addIssue({ code: 'custom', message: p.reason });
    return z.NEVER;
  }
  return p.e164;
});

export const SIMULATED_AUTORESPONSES = ['STOP', 'START', 'HELP'] as const;

export const SimulateInboundRequestSchema = z.object({
  /** One of the workspace's own (fake) numbers. */
  to: Phone,
  /** The merchant's phone (known or not). */
  from: Phone,
  text: z.string().max(1600, 'Use at most 1,600 characters'),
  /** Pretend Telnyx's own keyword handling answered this text. */
  autoresponseType: z.enum(SIMULATED_AUTORESPONSES).optional(),
});
export type SimulateInboundRequest = z.input<typeof SimulateInboundRequestSchema>;

export const SimulateInboundResponseSchema = z.object({
  eventId: z.string(),
  duplicate: z.boolean(),
});
export type SimulateInboundResponse = z.infer<typeof SimulateInboundResponseSchema>;
